module.exports = __webpack_public_path__ + "static/media/ios-magnet.436eacf1.svg";